import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NotificationsService } from '@viewbid/ts-angular-client';
import { VbSnackbarService } from '@viewbid/ui';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';

@Component({
    selector: 'vb-unsubscription-page',
    templateUrl: './unsubscription-page.component.html',
    styleUrls: ['./unsubscription-page.component.scss'],
})
export class UnsubscriptionPageComponent implements OnInit {
    subscriptionId: string | null = null;
    unsubscribeForm!: FormGroup;
    reasonOpions = [
        { value: 'TooFrequent', label: 'Too Frequent' },
        { value: 'Irrelevant', label: 'Irrelevant' },
        { value: 'PoorDesign', label: 'Poor Design' },
        { value: 'Other', label: 'Other' },
    ];
    formSubmitted = false;
    constructor(
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private snackbarService: VbSnackbarService,
        private notificationsService: NotificationsService,
        private translate: TranslateService,
        private recaptchaV3Service: ReCaptchaV3Service,
        private router: Router,
    ) {
        this.unsubscribeForm = this.fb.group({
            reason: [''],
        });
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe((params: ParamMap) => {
            this.subscriptionId = params.get('subscriptionId');
        });
    }

    public goToAuctions(): void {
        this.router.navigate([`/auctions`]);
    }

    public goToNotficationAndReminders(): void {
        this.router.navigate([
            `/profiles/my-profile/my-notifications-reminders`,
        ]);
    }

    onSubmit(): void {
        let selectedReason: string =
            this.unsubscribeForm.controls['reason'].value;

        // If no reason is selected or it is empty, set it to 'Other' from reasonOptions
        if (!selectedReason) {
            selectedReason =
                this.reasonOpions.find(
                    (option: any) => option.value === 'Other',
                )?.value || 'Other';
        }
        if (
            this.unsubscribeForm.valid &&
            selectedReason &&
            this.subscriptionId
        ) {
            let captchaToken: string = ``;
            this.recaptchaV3Service
                .execute('submit')
                .subscribe((token: string) => {
                    captchaToken = token;
                    if (captchaToken && this.subscriptionId) {
                        this.notificationsService
                            .unsubscribeNewsletters(
                                this.subscriptionId,
                                captchaToken,
                            )
                            .subscribe({
                                next: () => {
                                    const successMessage: string =
                                        this.translate.instant(
                                            'NewsLetters.SuccessfullUnSubscription',
                                        );
                                    this.snackbarService.success(
                                        successMessage,
                                    );
                                    this.formSubmitted = true;
                                },
                                error: () => {
                                    const failureMessage: string =
                                        this.translate.instant(
                                            'NewsLetters.UnSubscriptionFailed',
                                        );
                                    this.snackbarService.error(failureMessage);
                                },
                            });
                    }
                });
        }
    }
}
